'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('fpx'),
    isFunction = _require.isFunction,
    validate = _require.validate;

var _require2 = require('./observable'),
    Observable = _require2.Observable;

var _require3 = require('./reaction'),
    Reaction = _require3.Reaction;

var Computation = function (_Observable) {
  _inherits(Computation, _Observable);

  function Computation(def, equal) {
    _classCallCheck(this, Computation);

    validate(isFunction, def);
    validate(isFunction, equal);

    var _this = _possibleConstructorReturn(this, _Observable.call(this));

    _this.def = def;
    _this.equal = equal;
    _this.reaction = null;
    _this.value = undefined;
    return _this;
  }

  Computation.prototype.deref = function deref() {
    return this.value;
  };

  Computation.prototype.onInit = function onInit() {
    this.reaction = Reaction.loop(computationUpdate.bind(this));
  };

  Computation.prototype.onDeinit = function onDeinit() {
    this.reaction.deinit();
    this.reaction = null;
  };

  return Computation;
}(Observable);

exports.Computation = Computation;

function computationUpdate(reaction) {
  var prev = this.value;
  var next = this.value = this.def(reaction);
  if (!this.equal(prev, next)) this.trigger(this);
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/computation.js
// module id = 2048
// module chunks = 118